import { formControlStyles, defaultColor, defaultCheckedColor, formControlFontSizeStyles } from '../formControlStyles';
export const radioGroupStyles = {
    ...formControlStyles,
    radioButton: (uncheckedColor = defaultColor, checkedColor = defaultCheckedColor) => ({
        color: uncheckedColor,
        '& svg': {
            ...formControlFontSizeStyles,
            width: '1.3em',
            height: '1.3em',
        },
        '&.Mui-checked': {
            color: checkedColor,
        },
    }),
};
